import axios from "axios";

// Endpoint that receives enquiry form submissions and emails them to
// reservations@ninefurlongs.com. This points to the PHP mail handler
// (send-enquiry.php) hosted on the Nine Furlongs server.
const ENDPOINT = process.env.REACT_APP_ENQUIRY_ENDPOINT;

export async function submitEnquiry(data) {
  const res = await axios.post(ENDPOINT, data, {
    headers: { "Content-Type": "application/json" },
    timeout: 15000,
  });
  return res.data;
}
